export default __webpack_public_path__ + "static/media/assessment-level-1.4edc11fe.svg";